export default {
  API_BASE_URL: 'https://services.libaaxc.com/farmLife',
  API_BASE_URLv2: 'http://localhost:5002/farmLife',
  DEBUG: false,
};
